export default "__VITE_ASSET__640f0858__"